module.exports = ".error{\r\n    border: 1px solid red;\r\n  }\r\n  .nav-item span.caret{margin-left: 15px}"